function init404Page() {
  const section = document.getElementById("404");
  if (!section) return;

  const counter = document.getElementById("redirect-countdown");
  if (!counter) return;

  const homeUrl = counter.dataset.homeUrl;
  let seconds = 30;

  const interval = setInterval(() => {
    seconds--;
    counter.textContent = seconds;

    if (seconds <= 0) {
      clearInterval(interval);
      window.location.href = homeUrl;
    }
  }, 1000);
}

export { init404Page };
